import { useEffect, useState } from 'react';
import DateInput from './modal/DateInput';
import cleanDate from './tools/cleanDate';

export default function Modal({
  numDays,
  setNumDays,
  modalMode,
  onCloseModal,
  onAddTask,
  selectedTask,
  onEditTask,
  onDeleteTasks,
  today,
  selectedDay,
  setSelectedDay,
}) {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');

  useEffect(() => {
    if (modalMode === 'create') {
      setName('');
      setDescription('');
    } else if (modalMode === 'edit') {
      setName(selectedTask.name);
      setDescription(selectedTask.description);
    }
  }, [modalMode, selectedTask]);

  const id = new Date().getTime();

  if (modalMode === 'setting') {
    return (
      <div className="absolute z-10 top-0 left-0 right-0 bottom-0 pointer-events-none flex justify-center items-end modal-active">
        <div className="overlay" onClick={onCloseModal}></div>
        {/* modal */}
        <div className="modal bottom-50/100 max-w-sm rounded-2xl pb-4">
          <div className="text-3xl font-light border-b-1 border-black/10 w-full text-center pb-4">
            تنظیمات
          </div>

          <div className="flex items-center justify-between w-full space-x-4">
            <p className=" text-xl shrink-0">تعداد روز های قابل انتخاب</p>
            <input
              type="number"
              className="modal-input mt-2  grow-1 "
              value={numDays}
              onChange={e => setNumDays(Number(e.target.value))}
              placeholder="تعداد روز"
            />
          </div>

          <button
            type="button"
            className="w-full border-2  px-3 py-3 rounded-lg text-primary font-bold "
            onClick={onCloseModal}
          >
            بستن پنجره
          </button>
        </div>
      </div>
    );
  }
  function handleSubmit(e) {
    e.preventDefault();

    if (!name) return;

    if (modalMode === 'create') handleSubmitCreate();
    if (modalMode === 'edit') handleSubmitEdit();
  }

  function handleSubmitCreate() {
    const newTask = {
      id,
      date: cleanDate(selectedDay),
      name,
      description,
      done: false,
    };
    onAddTask(newTask);

    onCloseModal();
  }

  function handleSubmitEdit() {
    const editedTask = {
      id: selectedTask.id,
      date: cleanDate(selectedDay),
      name,
      description,
      done: selectedTask.done,
    };

    onEditTask(editedTask);

    onCloseModal();
  }
  function handleDelete() {
    onDeleteTasks(selectedTask.id);
    onCloseModal();
  }

  return (
    <div
      className={`absolute z-10 top-0 left-0 right-0 bottom-0 pointer-events-none flex justify-center items-end ${
        modalMode !== null ? 'modal-active' : ''
      }`}
    >
      <div className="overlay" onClick={onCloseModal}></div>
      {/* modal */}
      <form className="modal" onSubmit={handleSubmit}>
        <div className="text-3xl font-light">
          {modalMode === 'create' && 'ساخت فعالیت'}
          {modalMode === 'edit' && 'ویرایش فعالیت'}
        </div>

        <DateInput
          selectedDay={selectedDay}
          setSelectedDay={setSelectedDay}
          today={today}
          numDays={numDays}
        />

        <input
          type="text"
          className="modal-input mt-2  "
          value={name}
          onChange={e => setName(e.target.value)}
          placeholder="نام"
        />
        <textarea
          value={description}
          onChange={e => setDescription(e.target.value)}
          type="text"
          className="modal-input h-24 -mt-2"
          placeholder="توضیحات فعالیت..."
        />

        <div className="flex space-x-4 w-full">
          <button type="submit" className="w-2/3  btn-primary">
            {modalMode === 'create' ? 'ساختن فعالیت' : 'تایید'}
          </button>
          <button
            type="button"
            className="w-1/3 border-2 border-primary px-3 py-3 rounded-lg text-primary font-bold "
            onClick={onCloseModal}
          >
            انصراف
          </button>
          {modalMode === 'edit' ? (
            <>
              <button
                type="button"
                className=" border-2 border-red-600 px-6 py-3 rounded-lg text-red-600 font-bold mr-6"
                onClick={handleDelete}
              >
                حذف
              </button>
            </>
          ) : null}
        </div>
      </form>
    </div>
  );
}
